module.exports = __webpack_public_path__ + "static/media/encerrada_creditos_voce.21c20131.jpg";